import React from 'react';
import Head from 'src/layout/head/Head';
import { useSelector } from 'react-redux';

import ImageUpload from './components/image-upload';
import OrganisationInformation from './components/information';
import PayoutConfiguration from './components/payout-configuration';
import OrganisationFeatures from './components/features';
import ArchiveOrg from './components/archive-org';
import Banding from './components/banding';

const Settings = () => {
  const { organisation, enums } = useSelector((state) => state);
  const isAdmin = organisation.is_admin;

  return (
    <div>
      <Head title="Settings" />
      <div className="grid grid-cols-5 gap-8">

        <div className='col-span-3'>
          <OrganisationInformation organisation={organisation} enums={enums?.enums} isAdmin={isAdmin} />
          {isAdmin && <OrganisationFeatures organisation={organisation} isAdmin={isAdmin} />}
        </div>

        <div className='col-span-2'>
          {isAdmin && <ArchiveOrg organisation={organisation} isAdmin={isAdmin} />}

          <ImageUpload organisation={organisation} isAdmin={isAdmin} />

          {isAdmin && <Banding organisation={organisation} isAdmin={isAdmin} />}
          {isAdmin && <PayoutConfiguration organisation={organisation} isAdmin={isAdmin} />}

        </div>

      </div>

    </div>
  );
}

export default Settings;
